/* Popups.js */
import React, { useState } from "react";
import './popup.css'



export function EditNodePopup({ popupData, onSave, onClose }) {
  

  const { position, nodeData, nodeType, parentId } = popupData;
  // Lokale States
  const [name, setName] = useState(nodeData?.name || '');
  const [durationDays, setDurationDays] = useState(nodeData?.duration_days || 0);
  const [rolle, setRolle] = useState(nodeData?.rolle || '');
  const [clickupVorlageId, setClickupVorlageId] = useState(nodeData?.clickup_vorlage_id || '');
if (!popupData) return null;
  const handleSaveClick = () => {
    onSave({
      nodeId: nodeData.instance_id,
      nodeType,
      parentId,
      name,
      duration_days: durationDays,
      rolle,
      clickup_vorlage_id: clickupVorlageId,
    });
  };

  return (
    <div className="edit-popup" style={{ top: position.y, left: position.x }}>
      <div className="edit-popup-header">
        Edit {nodeType === 'group' ? 'Group' : 'Task'}
      </div>

      {/* Name */}
      <div className="edit-popup-row">
        <label>Name:</label>
        <input value={name} onChange={(e) => setName(e.target.value)} />
      </div>

      {nodeType === 'task' && (
        <>
          {/* Dauer */}
          <div className="edit-popup-row">
            <label>Dauer (Tage):</label>
            <input
              type="number"
              value={durationDays}
              onChange={(e) => setDurationDays(e.target.value)}
            />
          </div>

          {/* Rolle */}
          <div className="edit-popup-row">
            <label>Rolle:</label>
            <input
              value={rolle}
              onChange={(e) => setRolle(e.target.value)}
            />
          </div>

          {/* ClickUp-Vorlage */}
          <div className="edit-popup-row">
            <label>Tool Vorlage:</label>
            <input
              value={clickupVorlageId}
              onChange={(e) => setClickupVorlageId(e.target.value)}
            />
          </div>
        </>
      )}

      <div className="edit-popup-buttons">
        <button onClick={handleSaveClick} style={{backgroundColor:"GREEN"}}>Save</button>
        <button onClick={onClose} style={{backgroundColor:"RED"}}>Cancel</button>
      </div>
    </div>
  );
}

const PopupOption = ({ item, type, onClick }) => (
  <div className="popup-option" onClick={onClick}>
    <span>{item.fields.name}</span>
    <span className="popup-option-type">{type}</span>
  </div>
);

export function PopupToAddNewNodes({
  groupTemplates,
  taskTemplates,
  position,
  handleAddNode,
  handlePopupClose,
  currentEditingGroupId,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const lowerSearchTerm = searchTerm.toLowerCase();

  const filteredTasks = taskTemplates.filter((task) =>
    task.fields.name.toLowerCase().includes(lowerSearchTerm)
  );
  const filteredGroups = groupTemplates.filter((group) =>
    group.fields.name.toLowerCase().includes(lowerSearchTerm)
  );

  return (
    <div
      className="popup-container"
      style={{ top: position.y, left: position.x }}
    >
      <div className="popup-header">
        {/* Bubbliger "Close"-Button */}
        <button className="popup-close" onClick={handlePopupClose}>
          Close
        </button>

        {/* Suchfeld */}
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="popup-input"
        />
      </div>

      {/* Scroll-Container */}
      <div className="popup-options-container">
        {filteredTasks.map((task, index) => (
          <PopupOption
            key={`task-${index}`}
            item={task}
            type="Task"
            onClick={() => {
              handleAddNode(task, "task");
              handlePopupClose();
            }}
          />
        ))}

        {!currentEditingGroupId &&
          filteredGroups.map((group, index) => (
            <PopupOption
              key={`group-${index}`}
              item={group}
              type="Group"
              onClick={() => {
                handleAddNode(group, "group");
                handlePopupClose();
              }}
            />
          ))}
      </div>
    </div>
  );
}